import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: '#1a1b30',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: '8px',
      padding: '8px 12px',
      fontSize: '12px',
      color: '#E8EAF0',
      boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    }}>
      <p style={{ fontWeight: 600 }}>{`${payload[0].name}: ${payload[0].value}`}</p>
    </div>
  );
};

const ChartPie = ({
  data = [],
  title,
  dataKey = 'value',
  nameKey = 'name',
  colors = ['#3B82F6', '#DC1F26', '#22C55E', '#FBBF24', '#A78BFA', '#00C2FF'],
}) => {
  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
      boxSizing: 'border-box',
    }}>
      {title && (
        <h3 style={{
          color: '#E8EAF0',
          fontWeight: 600,
          fontSize: '13px',
          marginBottom: '8px',
          letterSpacing: '0.01em',
          flexShrink: 0,
        }}>
          {title}
        </h3>
      )}

      <div style={{ width: '100%' }}>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                dataKey={dataKey}
                nameKey={nameKey}
                animationDuration={1000}
                animationEasing="ease-out"
                label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                  const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
                  const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
                  return percent > 0.05 ? (
                    <text
                      x={x} y={y}
                      fill="white"
                      textAnchor={x > cx ? 'start' : 'end'}
                      dominantBaseline="central"
                      style={{ fontSize: 11, fontWeight: 700 }}
                    >
                      {`${(percent * 100).toFixed(0)}%`}
                    </text>
                  ) : null;
                }}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color || colors[index % colors.length]}
                    stroke="rgba(0,0,0,0.2)"
                    strokeWidth={1}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend
                verticalAlign="bottom"
                height={36}
                wrapperStyle={{ fontSize: 11, color: '#9BA3B8', paddingTop: 8 }}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 220, color: '#3E4460', fontSize: 13 }}>
            No hay datos para mostrar
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartPie;
